import { Application, Controller } from "stimulus"

export default class LocalDateController extends Controller {
  static values = { selectedTime: String, longDateFormat: String}

  static targets = [
    "utcDate", "utcHour", "utcLongDate"
  ]

  connect() {    
    this.options = {
      date: this.selectedTimeValue,
      formatDate: "ddd, DD MMM",
      formatLongDate: this.longDateFormatValue,
      formatHour: "HH:mm"
    }
    gon.moment.locale(gon.locale);
    var gmtDateTime = gon.moment.utc(this.selectedTimeValue, "YYYY-MM-DD HH:mm")
    var localDate = gmtDateTime.local().format(this.options.formatDate).replace(new RegExp("\\.", "g"),"");
    var localLongDate = gmtDateTime.local().format(this.options.formatLongDate).replace(new RegExp("\\.", "g"),"");
    var localHour = gmtDateTime.local().format(this.options.formatHour);
    if(this.hasUtcDateTarget){
      this.utcDateTarget.textContent = localDate;
    }
    if(this.hasUtcLongDateTarget){
      this.utcLongDateTarget.textContent = localLongDate;
    }
    if(this.hasUtcHourTarget){
      this.utcHourTarget.textContent = localHour;
    }
  }

}

const application = Application.start()
application.register("local-date", LocalDateController)
